import { registrationProgress, faceAuthenticationResult, faceAuthentication } from '@/api/ksH5RealName'
import store from '@/store'
import router from '@/router'
import { Toast } from 'vant'

export const routerJump = (routerPath) => {
  if (router.currentRoute.path !== routerPath) {
    router.push(routerPath);
  }
}

/**
 *  用户注册进度查询
 * @returns null
 */
export const checkRegistrationProgress = async () => {
  const res = await registrationProgress()
  console.log('---- checkRegistrationProgress ----:', res)
  if (res) {
    const { user_emergency_contacts, relationship_options, progress, user_identify } = res
    store.commit(
      'ksH5RealName/SET_USER_EMERGENCY_CONTACTS',
      user_emergency_contacts,
    )
    store.commit('ksH5RealName/SET_RELATIONSHIP_OPTIONS', relationship_options)
    store.commit('ksH5RealName/SET_PROGRESS', progress)
    store.commit('ksH5RealName/SET_USER_IDENTIFY', user_identify)
    switch (progress) {
      case '1':
        // 待填写紧急联系人，跳submit路由
        routerJump('/ksH5RealName/submit')
        break
      case '2':
        // 待上传身份证照片，跳submit路由
        routerJump('/ksH5RealName/submit')
        break
      case '3-1':
        // 如果当前是在重新上传状态且当前页在实名信息提交页,不跳人脸认证
        if (!(store.state.ksH5RealName.isAgainSubmit && router.currentRoute.path === '/ksH5RealName/submit')) {
          // 需要人脸认证
          routerJump('/ksH5RealName/authentication')
        }
        break
      case '3-2':
        // 如果当前是认证页或者当前是实名认证页的重新上传状态,不跳转loading页
        if (!(router.currentRoute.path === '/ksH5RealName/authentication' || (store.state.ksH5RealName.isAgainSubmit && router.currentRoute.path === '/ksH5RealName/submit'))) {
          routerJump('/ksH5RealName/loading')
        }
        break
      case '3-3':
        // 流程已完成跳success路由
        routerJump('/ksH5RealName/success')
        break
    }
  }
  return res
}
let checkFaceAuthenticationResultCount = 0
/**
 *  启动轮询查询人脸认证结果
 * @returns null
 */
/**
 *  查询人脸认证结果
 * @returns null
 */
export const checkFaceAuthenticationResult = async () => {
  try {

    const res = await faceAuthenticationResult()
    console.log('---- checkFaceAuthenticationResult ----:', router.currentRoute.path, res);
    if ([0,3].includes(res.esignFaceState)) {
      Toast('认证失败')
      routerJump('/ksH5RealName/authentication')
    } else if(res.esignFaceState === 1) {
      Toast('认证成功')
      routerJump('/ksH5RealName/success')
    } else if(res.esignFaceState === 2) {
      setTimeout(() => {
        checkFaceAuthenticationResultCount += 1
        if (checkFaceAuthenticationResultCount > 4) {
          Toast('认证超时')
          checkFaceAuthenticationResultCount = 0
          routerJump('/ksH5RealName/authentication')
          return
        }
        checkFaceAuthenticationResult()
      }, 1000)
    }
  }
  catch(err){
    Toast('认证失败')
    routerJump('/ksH5RealName/authentication')
  }
}

/**
 *  启动人脸认证
 * @returns null
 */
export const startFaceAuthentication = async () => {
  try {
    const res = await faceAuthentication({
      callback_url: window.location.origin + '/ksH5RealName/loading',
    })
    if (res.originalUrl) {
      window.location.href = res.originalUrl
    }
  }
  catch(err){
    routerJump('/ksH5RealName/authentication')
  }
}
